export const ROOT = '';
export const MAIN_PAGE_ROUTE = `${ROOT}/`;
export const LOGIN_PAGE_ROUTE = `${ROOT}/login`;
